import React, { memo } from 'react';
import cn from 'clsx';
import { Typography } from '../../../typography';
import { desktopCardText, mobileCardText, utpCardText } from './utp-card-text-styles';

type UtpCardTextProps = {
  text: string;
  mobileText?: string;
  className?: string;
};

export const UtpCardText: React.FC<UtpCardTextProps> = memo(({ className, mobileText, text }) => (
  <>
    <Typography
      adaptive={false}
      className={cn(utpCardText, className, { [desktopCardText]: mobileText })}
      size="body_long"
      variant="s">
      {text}
    </Typography>
    {mobileText && (
      <Typography
        adaptive={false}
        className={cn(utpCardText, className, { [mobileCardText]: mobileText })}
        size="body_long"
        variant="s">
        {mobileText}
      </Typography>
    )}
  </>
));
